import { SnowplowService } from 'wanderu-service-analytics';

function addReturnTripDropdownClicked({ tripId }) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: 'add_return_trip',
        property: {
            trip_id: tripId,
        },
    });
}

function addReturnDateSelected({ tripId, dateSelected }) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'select',
        category: 'react_tripsummary',
        label: 'add_return_trip_date',
        property: {
            date_selected: dateSelected,
            trip_id: tripId,
        },
    });
}

export default {
    addReturnDateSelected,
    addReturnTripDropdownClicked,
};
